import { render, staticRenderFns } from "./TokenContract.vue?vue&type=template&id=74fcc09a&scoped=true&"
import script from "./TokenContract.vue?vue&type=script&lang=ts&"
export * from "./TokenContract.vue?vue&type=script&lang=ts&"
import style0 from "./TokenContract.vue?vue&type=style&index=0&id=74fcc09a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fcc09a",
  null
  
)

export default component.exports